import "./index.css";

document.querySelector(
  ".Footer-copyright"
).innerHTML += `&nbsp;${new Date().getFullYear()}`;
